import {
  EyeInvisibleOutlined,
  EyeOutlined,
  HolderOutlined,
} from "@ant-design/icons";

export default function DraggableOption({
  item,
  isDragging,
  onDragStart,
  onDragEnd,
  isSelected,
  setHiddenFilters,
  hiddenFilters,
}) {
  const handleShow = () => {
    setHiddenFilters([...hiddenFilters, item]);
  };

  const handleHide = () => {
    setHiddenFilters((prev) => prev.filter((f) => f.name !== item.name));
  };

  const isVisible = hiddenFilters.some((f) => f.name === item.name);

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, item)}
      onDragEnd={onDragEnd}
      className={`flex items-center justify-between h-8 px-3 border rounded-lg cursor-move  border-primary-tint ${
        isVisible
          ? "bg-gray-200 border-gray-500 opacity-70"
          : isDragging || isSelected
          ? "bg-primary-tint !text-white"
          : "text-primary-tint"
      }`}
    >
      <div className="flex gap-3">
        <HolderOutlined />
        <label>{item?.name}</label>
      </div>
      {isVisible ? (
        <EyeInvisibleOutlined onClick={handleHide} className="cursor-pointer" />
      ) : (
        <EyeOutlined onClick={handleShow} className="cursor-pointer" />
      )}
    </div>
  );
}
